import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';

const certifications = [
  'OSHA 30 Familiarity',
  'ISO 9001-aligned QA Processes',
  'SOC 2-aware Data Handling',
  'EPA Lead-Safe Practices (context-aware)',
];

const clients = [
  'D.R. Horton (regional teams)',
  'Ferguson (distribution pilots)',
  'HomeServe (trade network pilot)',
  'Local GC & MEP contractors',
];

const Credentials = () => {
  return (
    <Box id="credentials" sx={{ py: 6 }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
        Credentials & Partners
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Certifications
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            {certifications.map((c, i) => (
              <Chip key={i} label={c} variant="outlined" />
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Selected Clients
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            {clients.map((c, i) => (
              <Chip key={i} label={c} />
            ))}
          </Box>
        </Grid>
      </Grid>
      <Box mt={3}>
        <Typography variant="body2" color="text.secondary">
          We partner with companies where we can create measurable competitive advantage; we are not the right fit for everyone.
        </Typography>
      </Box>
    </Box>
  );
};

export default Credentials;


